import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { DailyMatterReportGetResult } from '../../models/gen/dailyMatterReportGetResult';
import { IdParam } from '../../models/gen/idParam';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const DAILY_MATTER_REPORT_CONTEXT_NAMES = {
  POST_DAILY_MATTER_REPORT: 'postDailyMatterReport',
  GET_DAILY_MATTER_REPORT: 'getDailyMatterReport',
} as const;

const apis = apiGenerator();

/**
 * POST `/daily-matter-report`
 *
 * @param param -
 * @returns
 */
export const usePostDailyMatterReport = () =>
  useGenericMutation(async (param: FormData) =>
    apis.post(`${env.BASE_API_ENDPOINT}/daily-matter-report`, { data: param })
  );

/**
 * GET `/daily-matter-report/{id}`
 *
 * @param param -
 * @returns
 */
export const usePostDailyMatterReportSearch = (param: IdParam) =>
  useGenericQuery(
    [
      DAILY_MATTER_REPORT_CONTEXT_NAMES.GET_DAILY_MATTER_REPORT,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.get<void, DailyMatterReportGetResult>(
        `${env.BASE_API_ENDPOINT}/daily-matter-report/${param.id}`,
        { ...queryOptions }
      ),
    { enabled: false }
  );
